/* eslint-disable react/prop-types */
import { useState } from 'react';
import { IconButton, Snackbar, Alert } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import { tokens } from '../../../tokens';

function CopyChat ({ stringToCopy }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(stringToCopy);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        color="primary"
        style={{ padding: '1px', marginLeft: '4px' }}
      >
        <ContentCopyTwoToneIcon
          sx={{ color: tokens.token_surface, height: '18px', width: '18px' }}
        />
      </IconButton>
      <Snackbar
  
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={800}
        onClose={() => setOpen(false)}
        open={open}
      >
        <Alert severity="info">Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
}

export default CopyChat;
